export default __webpack_public_path__ + "static/media/ic_mexico.3d923cce.svg";